import React, { CSSProperties, useEffect } from 'react'

declare global {
  interface Window {
    adsbygoogle: any
  }
}

type Props = {
  client: string
  slot: string
  styles?: CSSProperties
  autoFormat?: boolean
  className?: string
}

const GoogleAd = ({ autoFormat = true, styles = { display: 'block' }, client, className, slot, ...rest }: Props) => {
  useEffect(() => {
    const pushAd = () => {
      try {
        const adsbygoogle = window.adsbygoogle
        adsbygoogle.push({})
      } catch (e) {
        // adsbygoogle.push() error: All ins elements in the DOM with class=adsbygoogle already have ads in them.
        // notifyAndLog(e)
      }
    }

    let tries = 6 // 1800ms max
    let interval = setInterval(() => {
      if (tries <= 0) {
        // we exceeded the tries, maybe the user has an adblock
        clearInterval(interval)
        return
      }

      // Check if Adsense script is loaded
      if (window.adsbygoogle) {
        pushAd()
        tries = 0
        clearInterval(interval)
      } else {
        tries--
      }

      return () => {
        clearInterval(interval)
      }
    }, 300)
  }, [slot, client])

  return (
    <ins
      className={className ? `adsbygoogle ${className}` : 'adsbygoogle'}
      style={styles}
      data-ad-client={client}
      data-ad-slot={slot}
      {...(autoFormat ? { 'data-ad-format': 'auto' } : {})}
      {...rest}
    />
  )
}

export default GoogleAd
